import { useState, useRef, useMemo } from "react";
import PropTypes from "prop-types";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { FlexContainers, IconButton, WrapperContainer } from "../../../../../../../../components";
import { WalkthroughSection } from "./WalkthroughSection";
import { Dot, SliderWrapper } from "./styled";
import { fileTypeConfigs, fileTypes } from "../../../../../../../../consts";

export const WalkthroughPreview = ({ releaseNotes, mediaData }) => {
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);

  const getMedia = (id) => {
    const media = mediaData.find((el) => el.id === id);
    const mediaType = media?.imageFile?.type;

    const isVideo = fileTypeConfigs[fileTypes.video].extensions.includes(mediaType);

    return { media: media?.imageFile, isVideo };
  };

  const firstItem = useMemo(() => {
    if (releaseNotes?.features?.length) {
      return releaseNotes?.features[0];
    }
  }, [releaseNotes]);

  const firstItemMedia = useMemo(() => {
    return getMedia(firstItem?.id);
  }, [firstItem]);

  let sliderRef = useRef(null);

  const settings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    beforeChange: (_, newIndex) => {
      setCurrentSlideIndex(newIndex);
    }
  };

  const onNext = () => {
    sliderRef.slickNext();
  };

  return (
    <SliderWrapper
      Container={FlexContainers.FlexColumnStart}
      gap={24}
      p={24}
      mb={16}
      maxWidth={600}>
      {releaseNotes?.features?.length > 1 ? (
        <Slider
          {...settings}
          ref={(slider) => {
            sliderRef = slider;
          }}>
          {releaseNotes?.features.map((item, index) => {
            const { media, isVideo } = getMedia(item?.id);

            return (
              <WalkthroughSection
                key={item?.id}
                title={item?.title}
                description={item?.description}
                media={media}
                isVideo={isVideo}
                isActive={currentSlideIndex === index}
                onNext={onNext}
              />
            );
          })}
        </Slider>
      ) : firstItem ? (
        <WrapperContainer Container={FlexContainers.FlexColumnStart} gap={8}>
          <WalkthroughSection
            key={firstItem?.id}
            title={firstItem?.title}
            description={firstItem?.description}
            media={firstItemMedia?.media}
            isVideo={firstItemMedia?.isVideo}
            isActive
          />
          <IconButton>
            <Dot />
          </IconButton>
        </WrapperContainer>
      ) : null}
    </SliderWrapper>
  );
};

WalkthroughPreview.propTypes = {
  releaseNotes: PropTypes.shape({
    features: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        icon: PropTypes.oneOfType([PropTypes.object, PropTypes.node]).isRequired,
        title: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired
      })
    ).isRequired
  }).isRequired,
  mediaData: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      imageFile: PropTypes.object.isRequired,
      mediaExtension: PropTypes.string.isRequired
    })
  ),
  thumbnailsData: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      imageFile: PropTypes.object.isRequired,
      mediaExtension: PropTypes.string.isRequired
    })
  )
};
